import { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { lock, unlock } from 'tua-body-scroll-lock';
import { formatMintues } from '../../../common/utils/formatMinutes';
import { BrandSitesV2Theme } from '../../BrandSitesV2/common/GlobalStyle';
import Portal from '../../Portal';
import CloseSvg from '../../svgs/CloseSvg';
import { apiClient } from '../../../lib/axios/apiClient';

interface Props {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  createdRecordId: number;
  setResultModalVisible: Dispatch<SetStateAction<boolean>>;
}

// const url = `${process.env.NEXT_PUBLIC_BASE_URL}/brand_site/office_inquire/request_consulting?c=lab`;
// apiClient.post(url, {
//   id: createdRecordId,
//   status: 'REQUESTED',
//   preferred_consultation_time: preferredConsultationTime,
// });

export default function PreferredTimeSelectModal({
  visible,
  setVisible,
  createdRecordId,
  setResultModalVisible,
}: Props) {
  const [preferTime, setPreferTime] = useState('');

  // 모달이 떠있을 때에 스크롤 방지
  useEffect(() => {
    if (visible) lock();
    else unlock();

    return unlock;
  }, [visible]);

  if (!visible) return null;

  return (
    <>
      <Portal>
        <Dim />
        <Container>
          <CloseIcon onClick={() => setVisible(false)}>{CloseSvg}</CloseIcon>
          <Title>{'상담 선호 시간'}</Title>
          <Desccription>{'상담 선호 시간을 선택해 주세요.\n선택된 시간에 전화드립니다.'}</Desccription>
          <InputWrapper style={{ flex: '1 0 90px' }}>
            <SelectArrow>{SelectArrowSvg}</SelectArrow>
            <Select
              defaultValue={''}
              onChange={(e) => setPreferTime(e.currentTarget.value)}
              $isNotSelected={!preferTime}
            >
              <option disabled value="" style={{ display: 'none' }}>
                통화 가능 시간 선택
              </option>
              <option value="09:00 ~ 11:00">09:00 ~ 10:00</option>
              <option value="09:00 ~ 11:00">10:00 ~ 11:00</option>
              <option value="11:00 ~ 13:00">11:00 ~ 12:00</option>
              <option value="11:00 ~ 13:00">12:00 ~ 13:00</option>
              <option value="14:00 ~ 15:00">14:00 ~ 15:00</option>
              <option value="15:00 ~ 16:00">15:00 ~ 16:00</option>
              <option value="15:00 ~ 16:00">16:00 ~ 17:00</option>
              <option value="17:00 ~ 18:00">17:00 ~ 18:00</option>
            </Select>
          </InputWrapper>
          <Button
            style={{ width: '100%' }}
            disabled={!preferTime}
            onClick={() => {
              if (createdRecordId) {
                const url = `${process.env.NEXT_PUBLIC_BASE_URL}/brand_site/office_inquire/request_consulting?c=lab`;
                apiClient.post(url, {
                  id: createdRecordId,
                  status: 'REQUESTED',
                  preferred_consultation_time: preferTime,
                });
              }

              setVisible(false);
              setResultModalVisible(true);
            }}
          >
            확인
          </Button>
        </Container>
      </Portal>
    </>
  );
}

const Dim = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: ${BrandSitesV2Theme.brandSitesV2.headerZIndex};
`;

const Container = styled.div`
  position: fixed;
  bottom: 50%;
  left: 50%;
  background: #ffffff;
  animation: none;
  border-radius: 16px;
  transform: translate(-50%, 50%);
  padding: 68px 24px 24px 24px;
  width: 415px;
  z-index: ${BrandSitesV2Theme.brandSitesV2.headerZIndex};

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    /* bottom: 0;
    left: 50%;
    transform: translate(-50%, 0); */
    /* width: 100%; */
    /* background: #ffffff; */
    /* border-radius: 16px 16px 0px 0px; */
    /* padding: 54px 24px; */
    max-width: calc(100% - 32px);
    /* animation: slidein 0.2s; */
  }

  /* @keyframes slidein {
    from {
      transfrom: translate(-50%, 100vh);
    }

    to {
      transfrom: translate(-50%, 0);
    }
  } */
`;

const CloseIcon = styled.div`
  position: absolute;
  cursor: pointer;
  top: 22px;
  right: 24px;
`;

const Title = styled.p`
  font-size: 25px;
  font-weight: 700;
  line-height: 140%;
  color: #000000d9;
  margin-bottom: 8px;
  text-align: center;
  white-space: pre-line;
`;

const Desccription = styled.p`
  font-size: 17px;
  font-weight: 400;
  line-height: 140%;
  text-align: center;
  color: #666666;
  margin-bottom: 32px;
  white-space: pre-line;
`;

const Button = styled.button`
  padding: 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 17px;
  line-height: 140%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  border: none;
  font-family: inherit;
  background: #00bed6;
  color: #ffffff;
  transition: 0.2s;
  user-select: none;

  &:disabled {
    background: rgba(0, 0, 0, 0.05);
    color: rgba(0, 0, 0, 0.2);
  }

  &:not(:disabled):hover {
    background: #19c4da;
  }
`;

const InputWrapper = styled.div`
  position: relative;

  margin-bottom: 32px;
`;

const Select = styled.select<{ $hasError?: boolean; $isNotSelected?: boolean }>`
  position: relative;
  box-shadow: ${({ $hasError }) => ($hasError ? '0 0 0 2px #ff5151' : 'none')};
  outline: none;
  border: none;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.03);
  width: 100%;
  font-family: inherit;
  font-size: 17px;
  font-weight: 400;
  padding: 14px 16px;
  color: ${({ $isNotSelected }) => ($isNotSelected ? '#999999' : 'rgba(0, 0, 0, 0.85)')};
  cursor: pointer;

  &::placeholder {
    color: rgba(0, 0, 0, 0.4);
  }

  appearance: none;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }
`;

const SelectArrow = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  user-select: none;
  pointer-events: none;
`;

const SelectArrowSvg = (
  <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4992 1.06761C15.772 1.34159 15.771 1.7848 15.497 2.05756L8.52772 8.99588C8.25461 9.26778 7.81309 9.26778 7.53998 8.99588L0.508754 1.99588C0.234778 1.72312 0.233792 1.27991 0.506551 1.00593C0.779308 0.731958 1.22252 0.730972 1.4965 1.00373L8.03385 7.51205L14.5093 1.06541C14.7832 0.79265 15.2264 0.793636 15.4992 1.06761Z"
      fill="#CCCCCC"
    />
  </svg>
);
